import {FRAGMENTS, HELPED_FRAGMENTS} from '../enums/enums';
import {replaceSquareBrackets} from './replaceSquareBrackets';

export const getIpAddress = () => {
  const facebookBusinessElement = document.querySelector(FRAGMENTS.DATA_ELEMENT);
  return facebookBusinessElement.getAttribute(replaceSquareBrackets(HELPED_FRAGMENTS.IP_ADDRESS));
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/getIpAddress.js